export * from './delete-gutachten-status-request.interface';
export * from './delete-gutachten-status-response.interface';
export * from './delete-gutachten-status.shapes';
